// import HeaderImage from "../../components/header-image/header-image";
// import VacantePrimaPagina from "../vacante/vacante-prima-pagina";
// import CarouselHomePageCorporate from "../../components/carousel/carousel-corporate-home-page";
// import CarouselHomePageLeisure from "../../components/carousel/carousel-leisure-home-page";
// import BlogPrimaPagina from "../blog/blog-prima-pagina";
// import Rezerva from "../../components/rezerva/rezerva";
// import GridPromoAfPremiumFEB26 from "../../components/grid-promo/grid-promo-feb-2026-af-premium.jsx";
// import GridPromoAfBusinessFEB26 from "../../components/grid-promo/grid-promo-feb-2026-af-business.jsx";
// import GridPromoKLPremiumFEB26 from "../../components/grid-promo/grid-promo-feb-2026-kl-premium.jsx";
// import GridPromoKLBusinessFEB26 from "../../components/grid-promo/grid-promo-feb-2026-kl-business.jsx";

// import GridPromoAfMAR from "../../components/grid-promo/grid-promo-mar-2026-AF.jsx";
// import GridPromoKlMAR from "../../components/grid-promo/grid-promo-mar-2026-KL.jsx";

// import GridPromoAfSEP26 from "../../components/grid-promo/grid-promo-sep-2026-af";
// import GridPromoKlmSEP26 from "../../components/grid-promo/grid-promo-sep-2026-kl";

import HomeHero from "../../components/home/HomeHero";
import HomeStats from "../../components/home/HomeStats";
import HomeAudiences from "../../components/home/HomeAudiences";
import HomeWhy from "../../components/home/HomeWhy";
import HomeRecognition from "../../components/home/HomeRecognition";
import HomePress from "../../components/home/HomePress";
import HomeCta from "../../components/home/HomeCta";
import HomeTeam from "../../components/home/HomeTeam";

// import PremiumPromo from "../../components/grid-promo/grid-promo-2025-klm";

const Home = () => {
  // const HeaderImg1 =
  //   "url('https://images.unsplash.com/photo-1520437358207-323b43b50729?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80')";

  return (
    <>
      {/* Header new */}

      {/* <GridPromoAfMAR />
      <GridPromoKlMAR /> */}

      {/* <GridPromoAfSEP26 />
      <GridPromoKlmSEP26 /> */}

      {/* <PremiumPromo /> */}
      {/* <TurkishAirlinesPromo /> */}
      <HomeHero />
      <HomeStats />
      <HomeAudiences />
      <HomeWhy />
      <HomeRecognition />
      <HomePress />
      <HomeTeam />
      <HomeCta />
      {/* Header New */}
      {/* <CarouselHomePageCorporate />
      <GridPromo /> */}
      {/* <CarouselHomePageLeisure />
      <VacantePrimaPagina /> */}
      {/* <GridPromoAfNov />
      <GridPromoKlNov />
      <BlogPrimaPagina />
      <HeaderImage HeaderImg={HeaderImg1} /> */}
    </>
  );
};

export default Home;
